import { ObservableFromFetch } from "../ObservableFromFetch"
import GridResponse from "../GridResponse"
import { Filter, Sort } from "../GridRequest"
import SendingFacilityRecord from "./Model/SendingFacilityRecord"
import Timezone from "./Model/Timezone"

const Columns = ["SendingFacility", "WS_Url", "Namespace", "SendingFacility_Code"] as const
type Column = typeof Columns[number]

export type ColumnFilters = Record<Column, string[]>
export type SendingFacilityGridResponse = GridResponse<SendingFacilityRecord> & ColumnFilters

function columnFilters(filters: Filter[]): ColumnFilters {
  return {
    SendingFacility: filters.find(filter => filter.column === "SendingFacility")?.values || [],
    WS_Url: filters.find(filter => filter.column === "WS_Url")?.values || [],
    Namespace: filters.find(filter => filter.column === "Namespace")?.values || [],
    SendingFacility_Code: filters.find(filter => filter.column === "SendingFacility_Code")?.values || []
  }
}

export default function SendingFacilityObservable(pageNumber: number, pageSize: number, filters: Filter[], sort?: Sort) {
  var params: object = {
    Filters: columnFilters(filters),
    PageNumber: pageNumber,
    PageSize: pageSize || 20,
    SortGrid: { SortColumn: sort?.column || "", SortOrder: sort?.order.toUpperCase() === "DESC" ? "DSC" : sort?.order.toUpperCase() }
  }

  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<SendingFacilityGridResponse>("SendingFacility/GetSendingFacilities", requestBody)
}

export function TimezoneObservable() {
  return ObservableFromFetch<Timezone[]>("CommonData/GetTimezones")
}

export function SaveSendingFacilityObservable(model: SendingFacilityRecord) {
  const requestBody: string = JSON.stringify(model)

  return ObservableFromFetch<SendingFacilityGridResponse>("SendingFacility/SetSendingFacility", requestBody)
}